module.exports = __webpack_public_path__ + "assets/img/1931591928118_.pic_hd.a2a7645b.jpg";